/**
 * External Dependencies
 */

import 'jquery';
import './vendor/hammer.min';
import './vendor/index';
import './vendor/drum';
import './vendor/simplyCountdown.min';

import PopupWebinaire from './popup_webinaire';

import ModuleServices from './modules/module-services/init';
import ModuleVideoContent from './modules/module-video-content/init';
import ModuleHeroImageVideo from './modules/module-hero-image-video/init';
import ModuleAproposEmploye from './modules/module-apropos-employes/init';
import ModuleCareer from './modules/module-career/init';
import ModuleToggleVideo from './modules/module-toggle-video/init';
import ModuleVideoInteractive from './modules/module-video-interactive/init';
import ModuleRouletteStatistique from './modules/module-roulette-statistique/init';
import ModuleLegendVideo from './modules/module-legend-video/init';
import ModuleImgGallery from './modules/module-img-gallery/init';
import ModuleScrollImg from './modules/module-scroll-img/init';
import PopupContact from './modules/module-popup-contact/init';
import ModuleParallaxImg from './modules/module-parallax-img/init';
import ModuleListPost from './modules/module-list-post/init';
import ModuleGmap from './modules/module-gmap/init';
import ModuleProfileInfo from './modules/module-profile-info/init';
import ModuleConfirmationPage from './modules/module-confirmation-page/init';
import moduleCalculatorPriceLittleBlocks from './modules/module-calculator-price-little-blocks/init';
import moduleCalculatorPriceTestimonial from './modules/module-calculator-price-testimonials/init';
import modulePopupEvenement from './modules/module-popup-evenement/init';
import modulePopupEcommerce from './modules/module-popup-ecommerce/init';
import modulePopupRh from './modules/module-popup-contact-rh/init';
import modulePopupConceptionWeb from './modules/module-popup-conception-web/init';
import modulePopupStrategieWeb from './modules/module-popup-strategie-web/init';
import moduleConsultation from './modules/module-popup-consultation/init';
import modulePopupVideo from './modules/module-popup-video/init';
import moduleButton from './modules/module-button/init';

import PageCulture from './modules/page-culture/init';
import PageSingleCareer from './modules/page-single-career/init';
import ModuleBlog from './modules/page-blog/init';
import PageSingleBlog from './modules/page-single-blog/init';

import CustomFormBehaviour from './modules/custom-form-behaviour/init';

import { Header } from './components/header';
import { Showreel } from './components/showreel';
import { Logo3dText } from './components/logo-3d-text';
import { RoundedCursor } from './components/rounded-cursor';
import { ListCustomCursor } from './components/list-custom-cursor';
import { CustomCursor } from './components/custom-cursor';
import { ClientsGrid } from './components/clients-grid';
import { FAQ } from './components/faq';
import { EventGrid } from './components/event-grid';
import { ListDetails } from './components/list-details';
import { Slider } from './components/slider';
import { Members } from './components/members';
import { ContactPage } from './components/contact-page';
import { AnchorScroll } from './components/anchor-scroll';

jQuery(function ($) {
	// NEW CODE
	const anchorScroll = new AnchorScroll();
	anchorScroll.init();

	if (document.querySelector('.header')) {
		const header = new Header();
		header.init();
	}

	if (document.querySelector('.showreel')) {
		const showreel = new Showreel();
		showreel.init();
	}

	if (document.querySelector('.logo3dText')) {
		const logo3dText = new Logo3dText();
		logo3dText.init();
	}

	if (document.querySelector('[data-cursor]')) {
		const roundedCursor = new RoundedCursor();
		roundedCursor.init();
	}

	if (document.querySelector('.listCustomCursor')) {
		const listCustomCursor = new ListCustomCursor();
		listCustomCursor.init();
	}

	if (document.querySelector('.customCursor')) {
		const customCursor = new CustomCursor();
		customCursor.init();
	}

	if (document.querySelector('.clientsGrid')) {
		const clientsGrid = new ClientsGrid();
		clientsGrid.init();
	}

	if (document.querySelector('.faq')) {
		const faq = new FAQ();
		faq.init();
	}

	if (document.querySelector('.eventGrid')) {
		const eventGrid = new EventGrid();
		eventGrid.init();
	}

	if (document.querySelector('.listDetails')) {
		const listDetails = new ListDetails();
		listDetails.init();
	}

	if (document.querySelector('.slider')) {
		const slider = new Slider();
		slider.init();
	}

	if (document.querySelector('.about-teamMembers')) {
		const members = new Members();
		members.init();
	}

	if (document.querySelector('.contactPage')) {
		const contactPage = new ContactPage();
		contactPage.init();
	}

	// OLD CODE
	if ($('.page-template-template-webinar').length > 0) {
		if ($('.page-template-template-webinar .row-testimonial')[0]) {
			$(
				'.page-template-template-webinar .webinar-page .row-testimonial'
			).slick({
				dots: false,
				infinite: true,
				speed: 300,
				slidesToShow: 1,
				slidesToScroll: 1,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							infinite: true,
							dots: true,
						},
					},
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						},
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						},
					},
				],
			});
		}
	}
	$(
		'.ebook .ebook-page .video_aside .video_calculateur, .webinar-page .row-video-webinar .div_video .video_calculateur'
	).on('click', function () {
		const iframe = $(this).find('iframe')[0];
		let videoContentPlayer = new Vimeo.Player(iframe);

		$(this).toggleClass('played');

		if ($(this).hasClass('played')) {
			videoContentPlayer.play();
			videoContentPlayer.setVolume(1);
		} else {
			videoContentPlayer.pause();
		}
	});

	// if ($('.page-template-template-ebook').length > 0) {
	// 	$(window).scroll(function (event) {
	// 		var scroll = $(window).scrollTop();
	// 		var ebookPage = $('.page-template-template-ebook .ebook-page').offset().top;

	// 		if (scroll >= ebookPage - 260) {
	// 			$(
	// 				'.page-template-template-ebook .ebook-page .container_second_section .content_to_show'
	// 			)
	// 				.slideDown('slow')
	// 				.animate({ opacity: 1 }, { queue: false, duration: '200' });
	// 		}
	// 	});
	// }

	if ($('#commentform').length) {
		// Validate Comment form
		$('#commentform').validate({
			messages: {
				author: 'Veuillez ajouter votre nom',
				email: 'Veuillez ajouter un courriel',
				comment: 'Veuillez ajoutez un commentaire',
			},
			errorElement: 'div',
			errorPlacement: function (error, element) {
				element.after(error);
			},
			submitHandler: function (form) {
				form.submit();
			},
		});
	}

	// Initialise les fil d'ariane à roulette
	for (var i = 0; i < $('.header_menu li').length; i++) {
		$('.language').append(
			`<option value=` +
				$($('.header_menu li a')[i]).attr('href') +
				`>
          ` +
				$($('.header_menu li a')[i]).text() +
				`</option>`
		);
	}

	for (var i = 0; i < $('.header_menu_page li').length; i++) {
		$('.language_page').append(
			`<option value=` +
				$($('.header_menu_page li a')[i]).attr('href') +
				`>
          ` +
				$($('.header_menu_page li a')[i]).text() +
				`</option>`
		);
	}

	// Fil d'arianne pour le header
	$('.language').drum({
		interactive: false,
	});
	$('.language_page').drum({
		interactive: false,
	});

	var scrollIndex = [];
	$('#main > [class^="module-"]').each(function () {
		if ($(this).find('section').prop('id') != '') {
			scrollIndex.push($(this).find('section').prop('id'));
		}

		if ($(this).find('section').prop('id')) {
			var dot_nav = $('<div class="module-navigation"></div>').append(
				$(
					'<span attr=' +
						$(this).find('section').prop('id') +
						' class="dot"></span>'
				)
			);

			$('.module-navigation-wrapper').append(dot_nav);
		}
	});

	$('.module-navigation span').on('click', function () {
		var scrollClass = $(this).attr('attr');

		$('html, body').animate(
			{
				scrollTop: $('#' + scrollClass).offset().top,
			},
			2000
		);
	});
	$('.module-navigation span').eq(0).addClass('active-dot');

	$(window).on('scroll', function () {
		$('#main > [class^="module-"]').each(function () {
			if ($(this).find('section').prop('id') != '') {
				var topPosition = $(this)[0].offsetTop;

				if ($(window).scrollTop() > topPosition) {
					for (var i = 0; i < scrollIndex.length; i++) {
						if (
							scrollIndex[i] == $(this).find('section').prop('id')
						) {
							$('.language')
								.eq($('.drum').index($(this).parent()))
								.drum('setIndex', i);
							$('.module-navigation span').removeClass(
								'active-dot'
							);

							$('.module-navigation span')
								.eq(i)
								.addClass('active-dot');
						}
					}
				}
			}
		});
	});

	// Scroll vers l'option sélectionné dans le fil d'ariane
	$('.drum-wrapper').on('mouseup', function () {
		$(this)
			.find('.drum figure')
			.each(function () {
				var figureValue = $(this);
				if (figureValue.css('opacity') == 1) {
					$('.language option').each(function () {
						if ($(this).text() == figureValue.text()) {
							var scrollClass = $(this)
								.attr('value')
								.replaceAll('http://', '');

							$('html, body').animate(
								{
									scrollTop: $(scrollClass).offset().top,
								},
								2000
							);
						}
					});
				}
			});
	});

	$($('.menu-detaille li ul').parent().find('a')[0]).removeAttr('href');

	$('.menu-detaille ul.menu > li.menu-item > a').each(function () {
		$(this).addClass('glitch');
		$(this).attr('title', $(this).text());
	});

	$('.footer-navigation .menu li a').each(function () {
		$(this).addClass('glitch light_glitch');
		$(this).attr('title', $(this).text());
	});

	/* $('.menu-item-has-children a').on('click', function (event) {
		if ($(this).parent('.menu-item-has-children').length) {
			event.preventDefault();
		}

		if ($(this).parent().find('ul').hasClass('activeList')) {
			$(this).next().slideUp(600);
			$(this).parent().find('ul').removeClass('activeList');
		} else {
			$(this).parent().find('ul').addClass('activeList');
			$(this).next().slideDown(600);
		}
	}); */

	$(window).on('scroll', function () {
		if ($(window).scrollTop() > 300) {
			$('#page-down').hide();
		} else {
			$('#page-down').show();
		}
	});

	// Met les liens des médias sociaux dans les anchors
	$('.button-wrapper')
		.children('div')
		.each(function () {
			var button = $(this);

			if (
				!button.hasClass('telephone-button') &&
				button.find('.textwidget p').length != 0
			) {
				var url = button.find('.textwidget p').text();
				button.find('a').attr('href', url);
			}
		});

	$('html').addClass('js');

	if ($('.popup-auto').length) {
		PopupWebinaire.init();
	}

	if ($('.service-link.vertical-arrow').length) {
		ModuleServices.init();
	}

	if ($('.module-video-content').length) {
		ModuleVideoContent.init();
	}
	ModuleHeroImageVideo.init();
	ModuleAproposEmploye.init();
	ModuleProfileInfo.init();
	ModuleToggleVideo.init();
	ModuleVideoInteractive.init();
	if ($('.module-career').length) {
		ModuleCareer.init();
	}

	ModuleRouletteStatistique.init();
	ModuleLegendVideo.init();
	ModuleImgGallery.init();
	ModuleScrollImg.init();
	ModuleParallaxImg.init();

	if ($('.module-calculator-price-testimonials').length) {
		moduleCalculatorPriceTestimonial.init();
	}
	if ($('.popup_conception-web').length) {
		modulePopupConceptionWeb.init();
	}
	if ($('.module-consultation').length) {
		moduleConsultation.init();
	}
	if ($('.popup_strategie-web').length) {
		modulePopupStrategieWeb.init();
	}
	if ($('.module-popup-video').length) {
		modulePopupVideo.init();
	}
	if ($('.popup_rh').length) {
		modulePopupRh.init();
	}
	if ($('.popup_ecommerce').length) {
		modulePopupEcommerce.init();
	}
	if ($('.popup_calculateur').length) {
		modulePopupEvenement.init();
	}

	PageCulture.init();

	PopupContact.init();

	if ($('.module-calculator-price-little-blocks').length > 0) {
		moduleCalculatorPriceLittleBlocks.init();
	}

	if ($('button[data-popup]').length > 0) {
		moduleButton.init();
	}

	if ($('.blog').length > 0) {
		ModuleBlog.init();
	}

	if ($('.confirmation-page').length > 0) {
		ModuleConfirmationPage.init();
	}

	if ($('.listPost').length > 0) {
		ModuleListPost.init();
	}

	if ($('.singleCareer').length > 0) {
		PageSingleCareer.init();
	}

	if ($('.single_blog_template').length > 0) {
		PageSingleBlog.init();
	}

	if ($('.customBehaviour').length) {
		CustomFormBehaviour.init();
	}

	if ($('.video-confirm').length) {
		$('.video-confirm').on('click', function () {
			const iframe = $(this).find('iframe')[0];
			let videoContentPlayer = new Vimeo.Player(iframe);

			$(this).toggleClass('played');

			if ($(this).hasClass('played')) {
				videoContentPlayer.play();
				videoContentPlayer.setVolume(1);
			} else {
				videoContentPlayer.pause();
			}
		});
	}
});

const getRandom = (min, max) => Math.random() * (max - min) + min;

let timeOutGlitch;
const onAnimationEnd = function (e, elt, min, max) {
	if (e.animationName === 'main-animation-logo') {
		elt.classList.remove('active');
		elt.offsetHeight;
		clearTimeout(timeOutGlitch);
		timeOutGlitch = setTimeout(
			() => elt.classList.add('active'),
			getRandom(min, max)
		);
	}
};
const glitch = ({ item, min = 4000, max = 8000, loop = true, init = true }) => {
	if (loop) {
		item.addEventListener('animationend', (e) =>
			onAnimationEnd(e, item, min, max, loop)
		);
	}

	//reset to initial state
	clearTimeout(timeOutGlitch);
	item.classList.remove('active');
	item.offsetHeight;

	//start anim
	if (init) {
		item.classList.add('active');
	} else {
		timeOutGlitch = setTimeout(
			() => item.classList.add('active'),
			getRandom(min, max)
		);
	}
};

const logo = document.getElementById('glitchLogo_menu');
if (logo) {
	const logoLoader = document.getElementById('glitchLogo');
	const glitchLogo_footer = document.getElementById('glitchLogo_footer');

	logo.addEventListener('mouseenter', () =>
		glitch({ item: logo, loop: false })
	);
	logo.addEventListener('mouseleave', () =>
		glitch({ item: logo, init: false })
	); //set back our Glitch routine when mouse leave

	if (glitchLogo_footer) {
		glitchLogo_footer.addEventListener('mouseenter', () =>
			glitch({ item: glitchLogo_footer, loop: false })
		);
		glitchLogo_footer.addEventListener('mouseleave', () =>
			glitch({ item: glitchLogo_footer, init: false })
		);
		glitch({ item: glitchLogo_footer });
	}

	glitch({ item: logo });
	if (logoLoader) {
		glitch({ item: logoLoader, min: 1000, max: 3000 });
	}
}
